import React, { useState, useEffect } from 'react';
import { useEditMode } from '../contexts/EditModeContext';

function LockIcon() {
  const [showModal, setShowModal] = useState(false);
  const [passphrase, setPassphrase] = useState('');
  const [error, setError] = useState('');
  const { isEditMode, setIsEditMode } = useEditMode();
  const [hasValidToken, setHasValidToken] = useState(false);

  useEffect(() => {
    // Check if token exists on mount
    const token = localStorage.getItem('editToken');
    setHasValidToken(!!token);
  }, []);

  const handleAuth = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch('/api/auth', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ passphrase })
      });
      const data = await res.json();
      if (data.success && data.token) {
        localStorage.setItem('editToken', data.token);
        setHasValidToken(true);
        setIsEditMode(true);
        setShowModal(false);
        setPassphrase('');
        setError('');
      } else {
        setError('Invalid passphrase');
      }
    } catch (err) {
      setError('Failed to authenticate');
    }
  };

  const handleToggle = async () => {
    if (isEditMode) {
      // Just exit edit mode, keep token
      setIsEditMode(false);
    } else {
      // Try to enter edit mode
      const token = localStorage.getItem('editToken');
      if (token) {
        // Validate token before enabling edit mode
        try {
          const res = await fetch('/api/auth/validate', {
            headers: { 'Authorization': `Bearer ${token}` }
          });
          if (res.ok) {
            // Token is valid
            setIsEditMode(true);
          } else {
            // Token is invalid, clear it and show login
            localStorage.removeItem('editToken');
            localStorage.removeItem('editMode');
            setHasValidToken(false);
            setShowModal(true);
          }
        } catch (err) {
          // Network error or server down, clear token and show login
          localStorage.removeItem('editToken');
          localStorage.removeItem('editMode');
          setHasValidToken(false);
          setShowModal(true);
        }
      } else {
        // No token, show login modal
        setShowModal(true);
      }
    }
  };

  return (
    <>
      <button 
        className={`lock-icon ${isEditMode ? 'logout' : ''}`}
        onClick={handleToggle}
        title={isEditMode ? 'Exit edit mode' : 'Enter edit mode'}
      >
        {isEditMode ? '🔓' : '🔒'}
      </button>
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>Enter Edit Mode</h2>
            <form onSubmit={handleAuth}>
              <input
                type="password"
                value={passphrase}
                onChange={(e) => setPassphrase(e.target.value)}
                placeholder="Passphrase"
                autoFocus
              />
              {error && <p className="error">{error}</p>}
              <div className="modal-buttons">
                <button type="submit" className="btn">Enter</button>
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default LockIcon;
